import Request from "@/common/net/request.js";
const request = new Request();
// 列表
export function getPage(data) {
  return request.send({
    url: `/pmy/freight/settlement/supplier/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 出账
export function reconcile(data) {
  return request.send({
    url: `/pmy/freight/settlement/supplier/settle`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 对账单详情中的订单列表
export function reconciliationOrders(data) {
  return request.send({
    url: `/pmy/freight/settlement/supplier/info/orders`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 对账单详情
export function reconciliationOrderDetail(data) {
  return request.send({
    url: `/pmy/freight/settlement/supplier/info?billId=${data.billId}`,
    method: "get",
  });
}
// 代理商结算单详情导出
export function downloadDetail(data) {
  return request.send({
    url: `/pmy/freight/settlement/supplier/info/export`,
    method: "post",
    data,
    config: {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 代理商结算单列表导出
export function downloadTable(data) {
  return request.send({
    url: `/pmy/freight/settlement/supplier/export`,
    method: "post",
    data,
    config: {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 代理商结算单统计总览
export function overview(data) {
  return request.send({
    url: `/pmy/freight/settlement/supplier/overview`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 删除
export function deleteInfo(billId) {
  return request.send({
    url: `/pmy/freight/settlement/supplier?billId=${billId}`,
    method: "delete"
  });
}

